import { FeedLensSchema, type FeedLens } from "./feed-lens.contract.ts";

const feedLensLabels: Record<FeedLens, string> = {
    "best-match": "Best matches",
    nearby: "Nearby",
    "needs-home-soon": "Needs a home soon",
};

export const feedLenses = FeedLensSchema.options.map((id) => ({
    id,
    label: feedLensLabels[id],
}));
